import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@domainstack/ui/skeleton";

/**
 * Skeleton for a single notification card matching NotificationCard layout.
 */
export function NotificationCardSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-8 shrink-0 rounded-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-start justify-between gap-2"><Skeleton className="h-5 w-32" /><Skeleton className="mt-0.5 size-2 shrink-0 rounded-full" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex h-[1lh] items-center"><Skeleton className="h-[13px] w-full" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-full p-3"><div className="flex gap-3">{t0}<div className="min-w-0 flex-1">{t1}<div className="text-[13px]">{t2}<div className="flex h-[1lh] items-center"><Skeleton className="h-[13px] w-3/4" /></div></div><Skeleton className="mt-1 h-4 w-20" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}